<template>
    <v-data-table
        :headers="headers"
        hide-actions
        :items="data">
        <template v-slot:items="{ item }">
            <td>{{ item.Name }}</td>
            <td>{{ item.CompanyName }}</td>
            <td>{{ item.WorkTypeName }}</td>
            <td>{{ item.RoleTypeCategoryName }}</td>
            <td>{{ alternativeRoleName(item) }}</td>
            <td>{{ item.AccountCode }}</td>
            <td>{{ item.SalaryCode }}</td>
            <td>
                <v-btn 
                    color="primary"
                    @click="openEdit(item)">
                    <span>Edit</span>
                </v-btn>
                <v-btn v-if="item.WorkTypeID == 2"
                    color="primary"
                    @click="showRates(item)">
                    <span>Rates</span>
                </v-btn>
            </td>
        </template>
    </v-data-table>
           
</template>

<script>
export default {
    props: {
        data: {
            required: true,
            value: Array
        }
    },
    data() {
        return {
            items: [],
            headers: [
                {
                    text: "Role Name",
                    value: "Name",
                    sortable: true
                },
                {
                    text: "Company",
                    value: "CompanyName",
                    sortable: true
                },
                {
                    text: "Work Type",
                    value: "WorkTypeID",
                    sortable: true
                },
                {
                    text: "Role Type",
                    value: "RoleTypeCategoryName",
                    sortable: true
                },
                {
                    text: "Alternative Role",
                    value: "AlternativeRoleTypeID",
                    sortable: true
                },
                {
                    text: "Account Code",
                    value: "AccountCode",
                    sortable: true
                },
                {
                    text: "Salary Code",
                    value: "SalaryCode",
                    sortable: true
                },
                {
                    text: "Edit",
                    value: "",
                    sortable: false
                }
            ]
        }
    },
    methods: {
        openEdit(item) {
            this.$emit("edit", item);
        },
        showRates(item){
            console.log('open rates button, emit showRates');
            this.$emit("showRates", item);
        },
        alternativeRoleName(role) {
            if(role.AlternativeRoleTypeID) {
                var exist = this.data.find(r=> r.RoleTypeID == role.AlternativeRoleTypeID);
                if(exist) {
                    return `${exist.Name} (${exist.WorkTypeName})`;
                } else {
                    return "";
                }
            } else {
                "";
            }
        }
    }
}
</script>